import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgUser = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M2.491 15H13.51q.696 0 1.093-.294.398-.287.398-.806 0-.735-.489-1.564-.489-.828-1.408-1.54-.91-.72-2.204-1.17-1.292-.457-2.907-.457-1.607 0-2.9.457-1.292.45-2.212 1.17-.91.711-1.4 1.54Q1 13.166 1 13.9q0 .52.398.806Q1.796 15 2.49 15M8 7.799a3.2 3.2 0 0 0 1.665-.457 3.45 3.45 0 0 0 1.218-1.231 3.4 3.4 0 0 0 .464-1.758 3.2 3.2 0 0 0-.464-1.704 3.35 3.35 0 0 0-1.218-1.208A3.26 3.26 0 0 0 8 1q-.894 0-1.657.45-.762.448-1.226 1.215a3.25 3.25 0 0 0-.455 1.703q0 .968.455 1.743.464.774 1.218 1.23A3.2 3.2 0 0 0 8 7.8"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUser);
export default ForwardRef;
